import ChooseCorrectOption from '@/services/book/training-states/choose-correct-options';
import FillTheGapText from '@/services/book/training-states/fill-the-gap-text';
import PutInOrder from '@/services/book/training-states/put-in-order';
import TrueFalse from '@/services/book/training-states/true-false';
import WordToGap from '@/services/book/training-states/word-to-gap';
import { ExerciseConverted } from '@/interfaces/class/exercises';
import { Training } from '@/interfaces/class/training';

const allowedTrainings : {
  [key: string]: undefined | Function;
} = {
  ChooseCorrectOption,
  FillTheGapText,
  PutInOrder,
  TrueFalse,
  WordToGap,
};

const getState = (exercise: ExerciseConverted) => {
  const updatedData : Training[] = [];

  exercise.data.forEach((el: Training) => {
    const trainingConverter = allowedTrainings[el.allowedTrainingTypes[0]];

    if (trainingConverter) {
      updatedData.push(trainingConverter(el));
    } else {
      updatedData.push(el);
    }
  });

  return {
    ...exercise,
    dataTraining: updatedData,
  };
};

export default getState;
